/**
 * LongReadLayout — centred long-read column.
 *
 * Authority: docs/contracts/DESIGN_IMPLEMENTATION_CONTRACT.md Section 8.
 * Tokens:    DS_SPACING.longReadMaxWidth (860px).
 *
 * Used by Deal Evaluator (FCA detail), Strategy Insights, and Knowledge Base
 * detail pane. Single div with max-width constraint and automatic horizontal
 * centring — no internal padding, no background, no border (the surface
 * decides its own surround).
 */

import React from 'react';
import PropTypes from 'prop-types';
import { DS_SPACING } from '@/config/ui-invariants';

export function LongReadLayout({ children, as: Tag = 'div', ...rest }) {
  return (
    <Tag
      {...rest}
      style={{
        maxWidth: DS_SPACING.longReadMaxWidth,
        marginLeft: 'auto',
        marginRight: 'auto',
        width: '100%',
        ...(rest.style || {}),
      }}
    >
      {children}
    </Tag>
  );
}

LongReadLayout.propTypes = {
  children: PropTypes.node,
  as: PropTypes.elementType,
};

export default LongReadLayout;
